import { render } from "./9.WhatWeOfferSection.vue?vue&type=template&id=afc9d128&scoped=true"
import script from "./9.WhatWeOfferSection.vue?vue&type=script&lang=js"
export * from "./9.WhatWeOfferSection.vue?vue&type=script&lang=js"

import "./9.WhatWeOfferSection.vue?vue&type=style&index=0&id=afc9d128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc9d128"]])

export default __exports__